define([
  "backbone",
  "marionette",
  "messaging/messenger",
  "modules/shared/progressBar/progressBarView",
], function (Backbone, Marionette, Messenger, ProgressBarView) {
  var ProgressBarController = Marionette.Controller.extend({
    initialize: function (options) {
      this.region = options.region;
      this.label = options.label;
      this.className = options.className;
      this.name = "progressBar";
    },
    show: function () {
      var progressBarModel = new Backbone.Model({
        label: this.label,
        className: this.className,
      });
      this.view = new ProgressBarView.progressBarView({ model: progressBarModel });
      this.showRegion(this.view);
    },
  });

  return ProgressBarController;
});
